// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountV2PrescribersHubGetPrescribersHubGetPrescribersResponse {
    static getAttributeTypeMap() {
        return AccountV2PrescribersHubGetPrescribersHubGetPrescribersResponse.attributeTypeMap;
    }
}
AccountV2PrescribersHubGetPrescribersHubGetPrescribersResponse.discriminator = undefined;
AccountV2PrescribersHubGetPrescribersHubGetPrescribersResponse.additionalProperties = false;
AccountV2PrescribersHubGetPrescribersHubGetPrescribersResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<PrescriberModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=accountV2PrescribersHubGetPrescribersHubGetPrescribersResponse.js.map